import { ajaxRequest } from "../Ajax/ajax"
import { successToast } from "../utils"


export function lostPassword(){

    $(document).on("click", "#reset-pw", function(e){
        e.preventDefault()

        const form = $("#rec")

        const data = form.serializeArray()

        const url = form.attr('action')

        const success = function(data){
            successToast(data.status)
        }

        $(this).prop('disabled', true)
        setTimeout(() => {
            $(this).prop('disabled', false)
        }, 5000)

        ajaxRequest(url, success, data, $(this))
    })

}